<template>
<div :style="{ height: `${vh - 170}px` }" class="flex align-items-center justify-content-center pt-3 pb-3">
 
</div>
</template>

<script lang="ts">

import Security from './security'
import {store} from './store'
import Utils from './utils';
//import {Models} from "@/components/models";
//import router from "@/router";
//import PrimevueButton from 'primevue/button';

export default {
  name: 'OrdersHome',
  components:{
      //PrimevueButton,

  },
    data() {
      return {
      store,
      vh: 0,
    }
  },

  computed: {
    Utils() {
      return Utils
    },
  },

  beforeMount() {

      if (Security.requireToken()){
        store.selectModul = this.$route.path.split("/")[1]
        this.setDynamicHeight(); 
        // Aktualizácia výšky pri zmene veľkosti okna
        window.addEventListener("resize", this.setDynamicHeight);
        //console.log("Route Orders params:", this.$route);
        Utils.getAttTypes()
      }
  },

  beforeUnmount() {
    window.removeEventListener("resize", this.setDynamicHeight);
  },

  methods: {
    setDynamicHeight() {
      this.vh = window.innerHeight; // Nastavenie viditeľnej výšky
    },
  },
}    
</script>